// BROOKSTAR ネーム刺繍セット: カート内でボディ行と刺繍加工行/割増行をまとめて1グループとして扱う。
// グループ内の個別行ステッパー・個別削除は封じ、「セット」単位のステッパー／削除のみを許可することで
// ボディだけ残して刺繍加工行だけ減らす／消すことができてしまう問題を防ぐ。
//
// 小ロット対応費行（variant 46441123971268）の増減ロジックは ua-small-lot-cart.js が
// window.UaSmallLotFee として公開している（addFeeLine/updateFeeLinesを内包したreconcile()）。
// このモジュールが自前のpubsub購読（cartUpdateイベントを80msデバウンスして非同期に処理）だけに頼ると、
// 「セット削除」「ステッパーで1〜9⇄10以上の閾値をまたぐ」ケースで反映が遅れる/取りこぼす実測不具合があったため、
// ここでは window.UaSmallLotFee.reconcile() を自分の更新完了後に直接・同期的に呼び出す。
// reconcile()は現在のカート状態を都度readCart()し直すべき状態と比較する冪等な実装なので、
// 後から遅れてpubsub経由のreconcile()が発火しても「変化なし」を検知してno-opになるだけで、二重追加/二重削除は起きない。
(function () {
  'use strict';

  var SMALL_LOT_FEE_VARIANT_ID = 46441123971268;
  var busy = false;

  function cartUpdateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  function cartJsUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return doc ? doc.innerHTML : '';
  }

  function getCartItemsElement(fromElement) {
    if (fromElement && typeof fromElement.closest === 'function') {
      var scoped = fromElement.closest('cart-items') || fromElement.closest('cart-drawer-items');
      if (scoped) return scoped;
    }
    return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  function setLoading(cartItemsEl, loading) {
    var container =
      (cartItemsEl && (cartItemsEl.id === 'CartDrawer-CartItems' ? cartItemsEl : null)) ||
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems');
    if (container) container.classList.toggle('cart__items--disabled', !!loading);
  }

  function reportError() {
    var errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
    if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
  }

  function replaceSections(cartItemsEl, parsedState) {
    if (!cartItemsEl || typeof cartItemsEl.getSectionsToRender !== 'function' || !parsedState.sections) return;
    cartItemsEl.getSectionsToRender().forEach(function (section) {
      var sectionHtml = parsedState.sections[section.section];
      if (!sectionHtml) return;
      var container = document.getElementById(section.id);
      if (!container) return;
      var target = (section.selector && container.querySelector(section.selector)) || container;
      target.innerHTML = getSectionInnerHTML(sectionHtml, section.selector || target.tagName.toLowerCase());
    });
  }

  // 現在のカート内容を取得する。削除時に「残りのコンフィギュレーター由来ボディ数量」と
  // 「小ロット対応費行のkey」を判断するために使う。
  function fetchCartItems() {
    return fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return cart.items || [];
      });
  }

  function isConfiguredBodyItem(item) {
    var props = item.properties || {};
    return props._ua_configurator === 'p2b' && props._ua_item_type === 'body';
  }

  function isSmallLotFeeItem(item) {
    var props = item.properties || {};
    return (
      Number(item.variant_id) === SMALL_LOT_FEE_VARIANT_ID ||
      props._ua_small_lot_fee === 'true' ||
      props._ua_item_type === 'small_lot_fee'
    );
  }

  function sendCartUpdate(triggerEl, updates) {
    if (busy || !Object.keys(updates).length) return;
    busy = true;

    var cartItemsEl = getCartItemsElement(triggerEl);
    setLoading(cartItemsEl, true);

    var sections =
      cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function'
        ? cartItemsEl.getSectionsToRender().map(function (section) {
            return section.section;
          })
        : undefined;

    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsedState) {
        if (parsedState.errors) {
          reportError();
          return;
        }
        replaceSections(cartItemsEl, parsedState);
        var cartDrawerWrapper = document.querySelector('cart-drawer');
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        var cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', parsedState.item_count === 0);

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: parsedState,
            variantId: null
          });
        }
      })
      .catch(function (error) {
        console.error('[ua-cart-sets] cart update failed', error);
        reportError();
      })
      .finally(function () {
        setLoading(cartItemsEl, false);
        busy = false;
      });
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  // sections付きの/cart/update.jsを叩いて現在のsections HTMLを取得するだけの1回分の試行。
  // updates:{} の無害な（数量を変えない）呼び出し。
  // ステッパー直後は ua-small-lot-cart.js 側のpubsub経由reconcileも同時に別リクエストを
  // 投げている可能性があり、Shopifyのカートエンドポイントが稀にHTML（doctype）を返す
  // ことを実測したため、非JSON応答はエラー扱いにして呼び出し側でリトライできるようにする。
  function fetchSectionsOnce(sections) {
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: sections, sections_url: window.location.pathname })
    }).then(function (response) {
      return response.text().then(function (text) {
        var trimmed = text.trim();
        if (!response.ok || trimmed.charAt(0) !== '{') {
          throw new Error('cart sections fetch returned non-JSON (status ' + response.status + ')');
        }
        return JSON.parse(trimmed);
      });
    });
  }

  // fee行の増減が実際に起きた後、画面（cart-items/cart-drawer-items/main-cart-footer）を
  // 自前で確実に再描画する。ua-small-lot-cart.js側のpublishRefresh→onCartUpdate()の
  // 非同期経路に頼ると「カートデータは更新済みだが画面表示だけ古いまま」になる実測不具合があったため、
  // sendCartUpdateと同じ仕組み（sections付きの/cart/update.js）で明示的に取り直す。
  // 稀に非JSON応答が返るケースを踏まえ、最大2回まで（間隔をあけて）リトライする。
  function refreshCartSections(triggerEl, attempt) {
    attempt = attempt || 1;
    var cartItemsEl = getCartItemsElement(triggerEl);
    var sections =
      cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function'
        ? cartItemsEl.getSectionsToRender().map(function (section) {
            return section.section;
          })
        : undefined;
    if (!sections) return Promise.resolve();

    return fetchSectionsOnce(sections)
      .then(function (parsedState) {
        if (parsedState.errors) return;
        replaceSections(cartItemsEl, parsedState);
      })
      .catch(function (error) {
        if (attempt < 3) {
          return delay(400 * attempt).then(function () {
            return refreshCartSections(triggerEl, attempt + 1);
          });
        }
        console.error('[ua-cart-sets] section refresh after fee reconcile failed', error);
      });
  }

  // window.UaSmallLotFee.reconcile() を直接呼ぶ（pubsub経由の非同期発火に頼らない）。
  // reconcile()はカート状態の増減が実際にあったかを {changed: boolean} で返す実装なので、
  // 変化があった場合だけ画面を明示的に再描画する（変化なしなら余計な通信をしない）。
  // 未ロード環境でも壊れないようガードする。
  function reconcileSmallLotFee(triggerEl) {
    if (!window.UaSmallLotFee || typeof window.UaSmallLotFee.reconcile !== 'function') {
      return Promise.resolve();
    }
    return window.UaSmallLotFee.reconcile()
      .then(function (result) {
        if (result && result.changed) {
          return refreshCartSections(triggerEl);
        }
      })
      .catch(function (error) {
        // reconcile()が例外で終わっても、内部の更新/追加リクエスト自体はサーバー側で
        // 既に適用されていることがある（実測: /cart/update.jsが200でJSONでない応答を
        // 返すケースがあり、その場合でもfeeの増減自体は反映済みだった）。
        // 画面がカートの実状態と食い違ったまま残らないよう、失敗時も必ず再取得して同期する。
        console.error('[ua-cart-sets] small-lot fee reconcile failed', error);
        return refreshCartSections(triggerEl);
      });
  }

  function parseKeys(el) {
    var raw = el.getAttribute('data-ua-item-keys') || '';
    return raw
      .split(',')
      .map(function (key) {
        return key.trim();
      })
      .filter(Boolean);
  }

  function handleDelete(button) {
    var keys = parseKeys(button);
    if (!keys.length || busy) return;
    if (!window.confirm('このネーム刺繍セットをカートから削除しますか？')) return;

    var keySet = {};
    keys.forEach(function (key) {
      keySet[key] = true;
    });

    fetchCartItems()
      .then(function (items) {
        var remainingBodyQty = 0;
        var feeKeys = [];
        items.forEach(function (item) {
          if (keySet[item.key]) return; // このセットの行は削除対象なので集計から除外
          if (isConfiguredBodyItem(item)) remainingBodyQty += Number(item.quantity) || 0;
          if (isSmallLotFeeItem(item)) feeKeys.push(item.key);
        });

        var updates = {};
        keys.forEach(function (key) {
          updates[key] = 0;
        });
        // このセットを消すとコンフィギュレーター由来のボディが1枚も残らない場合は、
        // 小ロット対応費行も同じリクエストで確実にqty 0にする（非同期reconcile任せにしない）。
        if (remainingBodyQty === 0) {
          feeKeys.forEach(function (key) {
            updates[key] = 0;
          });
        }

        return sendCartUpdate(button, updates);
      })
      .then(function () {
        // 上のqty0更新で既に確実にfee行を消しているはずだが、保険として現在状態も確認しておく
        // （冪等なので変化がなければ何もしない）。
        return reconcileSmallLotFee(button);
      })
      .catch(function (error) {
        console.error('[ua-cart-sets] delete failed', error);
        reportError();
      });
  }

  function handleStepper(stepperEl, delta) {
    // busy中は無視する。busyチェックなしで先にdata-ua-qty/表示テキストだけ楽観更新してしまうと、
    // 連打時に「表示だけ進むがリクエストはsendCartUpdate内のbusyガードで握りつぶされる」→
    // 後から前のリクエストの応答でセクションごと置き換わって表示が巻き戻る、という
    // 「数量が不安定に見える」不具合が起きるため、ここで先に弾く。
    if (busy) return;
    var keys = parseKeys(stepperEl);
    if (!keys.length) return;
    var current = parseInt(stepperEl.getAttribute('data-ua-qty'), 10);
    if (!current || current < 1) current = 1;
    var next = current + delta;
    if (next < 1) return;
    stepperEl.setAttribute('data-ua-qty', String(next));
    var valueEl = stepperEl.querySelector('[data-ua-set-qty]');
    if (valueEl) valueEl.textContent = String(next);

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = next;
    });

    var updatePromise = sendCartUpdate(stepperEl, updates);
    if (updatePromise && typeof updatePromise.then === 'function') {
      // ボディ合計が1〜9⇄10以上の閾値をまたいだ可能性があるので、更新完了後すぐに
      // 小ロット対応費の要否を直接確認する（pubsubの非同期発火待ちにしない）。
      updatePromise.then(function () {
        return reconcileSmallLotFee(stepperEl);
      });
    }
  }

  document.addEventListener('click', function (event) {
    var deleteBtn = event.target.closest('[data-ua-set-delete]');
    if (deleteBtn) {
      event.preventDefault();
      handleDelete(deleteBtn);
      return;
    }

    var minusBtn = event.target.closest('[data-ua-set-minus]');
    if (minusBtn) {
      event.preventDefault();
      var stepperForMinus = minusBtn.closest('[data-ua-set-stepper]');
      if (stepperForMinus) handleStepper(stepperForMinus, -1);
      return;
    }

    var plusBtn = event.target.closest('[data-ua-set-plus]');
    if (plusBtn) {
      event.preventDefault();
      var stepperForPlus = plusBtn.closest('[data-ua-set-stepper]');
      if (stepperForPlus) handleStepper(stepperForPlus, 1);
    }
  });
})();
